"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8214 14c-1.3214-4 0-8 4.1736-12C13.0099 7 20 9 20 14s-3.4435 8-8.005 8c-7.0094 0-10.028-8.5-6.54-13 0 2 1.045 4.5 2.3664 5zm3.8895 1c.4815 1.5.6774 3-.8449 4 2.5372.5 5.5819-1 4.8823-4-.5748-2.4653-3.3599-3-4.3748-5-.9275 1.5-.1441 3.5.3374 5z"
  })];
};

exports.default = _default;